import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Bundles from '../../../../api/api-bundles';
import update from 'immutability-helper';
import { get, includes } from 'lodash';
import { Profile } from '../../../../api/api-profile';
import { MessageDetails } from '../../app-bookings-messages/message-main';
import { Spinner } from 'shared-components/decorators/spinner';
import rootReducer from '../../app-main/reducers';
import ReviewOfferDetailsIOSModal from '../../app-bookings-custom/modals/ReviewOfferDetailsIOSModal';
import CurrentDetailsIOSModal from '../../app-bookings-current-details/current-details-ios-modal';
import ReviewRequestIOSModal from '../../app-bookings-request/modals/ReviewRequestIOSModal';
import { UpdateBookingIOSModal } from '../../app-bookings-update/update-booking-ios-modal';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { BookingStatus } from '../../app-bookings-messages/booking-status';
import { IOSFlowContainer } from '../../app-bookings-messages/ios-flow-container';

export class IOSBookingDetails extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};

    this.reviewCb = this.reviewCb.bind(this);
    this.getBookingMessageBundle = this.getBookingMessageBundle.bind(this);
    this.fetchState = this.fetchState.bind(this);
    this.renderReviewOfferDetails = this.renderReviewOfferDetails.bind(this);
  }

  componentDidMount () {
    this.fetchState();
    const mainContainer = document.getElementById('main-container');
    mainContainer.style.marginTop = 0;

    if (!this.state.contracts) {
      this.getBookingMessageBundle();
    }
  }

  getBookingMessageBundle (callback) {
    const {
      accessToken,
      bookingId } = this.props;
    const path = `bookings-inbox/${bookingId}`;
    // get booking obj
    Bundles.read(path, accessToken, (response) => {
      if (response.error || 400 < response.statusCode) {
        return this.setState({ isError: true });
      }
      const updatedDetails = get(response, 'update_details.new_values');
      if (updatedDetails) {
        // these properties are one level above the rest of the details data
        updatedDetails.guest_payment_processing_fee_percent_formatted = get(response, 'update_details.guest_payment_processing_fee_percent_formatted');
        updatedDetails.host_payout_processing_fee_percent_formatted = get(response, 'update_details.host_payout_processing_fee_percent_formatted');
        updatedDetails.guest_payment_amount_difference = get(response, 'update_details.guest_payment_amount_difference');
        updatedDetails.host_payout_amount_difference = get(response, 'update_details.host_payout_amount_difference');
        updatedDetails.expires_in = get(response, 'update_details.expires_in');
      }
      this.setState({
        details: response.details,
        isError: false,
        updatedDetails,
        guestCanUpdate: response.can_guest_update,
        hostCanUpdate: response.can_host_update,
        canInstantBook: response.can_instant_book,
        contracts: response.contracts,
        pendingContracts: response.pending_contracts,
        hasNoContracts: response.has_no_contracts
      }, () => {
        $('body').scrollTop(0);
      });
      if (callback) {
        callback();
      }
      return null;
    });
  }

  closeModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  reviewCb () {
    const newDetails = update(this.state.details, { review: { complete: { $set: true } } });
    this.setState({
      details: newDetails
    });
    this.closeModal();
  }

  fetchState () {
    const { accessToken, SSOID, bookingId } = this.props;
    let profile;
    Profile.read(`/v1/profiles/${SSOID}`, accessToken, (profileResponse) => {
      if (profileResponse.error || 400 < profileResponse.statusCode) {
        return this.exitNativeBridgeOnError();
      }
      profile = profileResponse;
      Bundles.read(`bookings-inbox/${bookingId}`, accessToken, (bundleResponse) => {
        if (bundleResponse.error || 400 < bundleResponse.statusCode) {
          return this.exitNativeBridgeOnError();
        }
        const updatedDetails = get(bundleResponse, 'update_details.new_values');
        if (updatedDetails) {
          // these properties are one level above the rest of the details data
          updatedDetails.guest_payment_processing_fee_percent_formatted = get(bundleResponse, 'update_details.guest_payment_processing_fee_percent_formatted');
          updatedDetails.host_payout_processing_fee_percent_formatted = get(bundleResponse, 'update_details.host_payout_processing_fee_percent_formatted');
          updatedDetails.guest_payment_amount_difference = get(bundleResponse, 'update_details.guest_payment_amount_difference');
          updatedDetails.host_payout_amount_difference = get(bundleResponse, 'update_details.host_payout_amount_difference');
          updatedDetails.expires_in = get(bundleResponse, 'update_details.expires_in');
        }
        return this.setState({
          profile,
          details: bundleResponse.details,
          updatedDetails,
          guestCanUpdate: bundleResponse.can_guest_update,
          hostCanUpdate: bundleResponse.can_host_update,
          canInstantBook: bundleResponse.can_instant_book,
          cancelUpdateDetails: bundleResponse.cancel_update_details,
          contracts: bundleResponse.contracts,
          hasNoContracts: bundleResponse.has_no_contracts,
          locale: get(profile, 'preferred_locale', 'en-US')
        }, () => { console.log(this.state); });
      });
      return null;
    });
  }

  exitNativeBridgeOnError () {
    window.NativeBridge.call('iOSBookingDetails.lastResort', null, () => {});
  }

  renderReviewOfferDetails (objState, hostView) {
    const { accessToken, SSOID, bookingId, contracts } = this.props;
    const store = createStore(rootReducer, applyMiddleware(thunk));
    const showCurrentDetails = includes(['EXECUTED', 'ACTIVE', 'EXPIRED', 'DECLINED', 'WITHDRAWN', 'CANCELLED', 'REQUESTED'], objState);

    if ('REQUESTED' === objState && hostView) {
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC iosLocale={this.state.locale}>
            <ReviewRequestIOSModal
              accessToken={accessToken}
              bookingId={bookingId}
              profile={this.state.profile}
              finalCb={this.fetchState}
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    if ('GUEST_UPDATE_REQUESTED' === objState) {
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC iosLocale={this.state.locale}>
            <UpdateBookingIOSModal
              updateAction="REVIEW_UPDATE"
              accessToken={accessToken}
              user={this.state.profile}
              bookingID={bookingId}
              customCb={this.fetchState}
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    if (showCurrentDetails) {
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC iosLocale={this.state.locale}>
            <CurrentDetailsIOSModal
              accessToken={accessToken}
              bookingId={bookingId}
              ssoId={SSOID}
              contracts={contracts}
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }

    ReactDOM.render(
      <Provider store={store}>
        <SharedIntlProviderHOC iosLocale={this.state.locale}>
          <ReviewOfferDetailsIOSModal
            accessToken={accessToken}
            bookingId={bookingId}
            ssoId={SSOID}
            contracts={contracts}
            iosWebView
            finalCb={this.fetchState}
          />
        </SharedIntlProviderHOC>
      </Provider>, document.getElementById('modal-container'));
    return null;
  }

  render () {
    const {
      details,
      profile,
      contracts,
      guestCanUpdate,
      updatedDetails,
      canInstantBook,
      hostCanUpdate,
      hasNoContracts,
      cancelUpdateDetails,
      pendingContracts
    } = this.state;

    const { accessToken, SSOID, iosConcierge, dispatch } = this.props;

    if (details && profile) {
      const firstName = 'GUEST' === details.view_as
        ? get(details, 'host.name.first')
        : get(details, 'guest.name.first');
      if ('undefined' !== typeof analytics) {
        analytics.track('render ios booking details', { time: Date.now(), user_id: SSOID });
      }
      return (
        <SharedIntlProviderHOC iosLocale={this.state.locale}>
          <BookingStatus
            details={details}
            name={firstName}
            user={profile}
            bundleUpdateRequest={this.getBookingMessageBundle}
            iosWebView
            guestCanUpdate={guestCanUpdate}
            updatedDetails={updatedDetails}
            canInstantBook={canInstantBook}
            hostCanUpdate={hostCanUpdate}
            hasNoContracts={hasNoContracts}
            cancelUpdateDetails={cancelUpdateDetails}
            accessToken={accessToken}
            dispatch={dispatch}
            contractData={contracts}
            pendingContracts={pendingContracts}
            iosConcierge={iosConcierge}
          >
            <IOSFlowContainer
              details={details}
              renderReviewOfferDetails={this.renderReviewOfferDetails}
              iosWebView
            >
              <MessageDetails
                name={firstName}
                bundleUpdateRequest={this.getBookingMessageBundle}
                reviewCb={this.reviewCb}
                accessToken={accessToken}
                iosWebView
                renderReviewOfferDetails={this.renderReviewOfferDetails}
                contractData={contracts}
                iosConcierge={iosConcierge}
                {...this.state}
              />
            </IOSFlowContainer>
          </BookingStatus>
        </SharedIntlProviderHOC>);
    }
    return <Spinner additionalStyle="spinner-mobile-page" />;
  }
}
